import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9 9H4v1h5z" }, null, -1),
    _createElementVNode("path", { d: "M7 12V7H6v5z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "m5 3 1-1h7l1 1v7l-1 1h-2v2l-1 1H3l-1-1V6l1-1h2zm1 2h4l1 1v4h2V3H6zm4 1H3v7h7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }